import type { MyLoanInfo } from "pages/application/applicationService";
import { ENCOMPASS_LOS_TYPE } from "utilities/loan-sidebar/constants";

export type LoanSelectionSource = "sidebar" | "my_loans_card";

export type LoanSelectionLosType = typeof ENCOMPASS_LOS_TYPE | "vesta";

export interface LoanSelectionRouterParams {
  loan: MyLoanInfo;
  losType: LoanSelectionLosType;
  loanKey: string;
  source: LoanSelectionSource;
}

export type NavigateToPostAuthHandler = (
  params: Pick<LoanSelectionRouterParams, "loan" | "losType" | "loanKey">,
) => void;

/**
 * FE-04 interim: Encompass loan selection delegates to navigateToPostAuth.
 * Nav components must not embed journey-resolution rules.
 */
export function routeLoanSelection(
  params: LoanSelectionRouterParams,
  navigateToPostAuth: NavigateToPostAuthHandler,
): void {
  if (params.losType !== ENCOMPASS_LOS_TYPE) {
    return;
  }

  navigateToPostAuth({
    loan: params.loan,
    losType: params.losType,
    loanKey: params.loanKey,
  });
}
